var render = function render(){var _vm=this,_c=_vm._self._c;return _c('CompanyBranding',{attrs:{"isMSDCustom":"","customCompanyId":_vm.companyId,"customActivePage":_vm.activePage}})
}
var staticRenderFns = []

export { render, staticRenderFns }